import { createEnum } from "../../../utils/utils";

export const BillableApi = createEnum({
  KYC: "KYC",
  KYB: "KYB",
  INDIVIDUAL_AML: "Individual AML",
  BUSINESS_AML: "Business AML",

  VAULT_CREATION: "Vault Creation",
  VAULT_CARD_DETAILS: "Vault Card Details",
  VAULT_PERSONAL_DETAILS: "Vault Personal Details",
  VAULT_CARD_PERSONAL_DETAILS: "Vault Card Personal Details",
  VAULT_ANY: "Vault Any",
  VAULT_BANK_BENEFICIARY: "Vault Bank Beneficiary",

  ONCHAIN_WALLET_ANALYSIS: "On-chain Wallet Analysis",
  CONSENT_NOTE: "Consent Note",
  ONGOING_AML: "Ongoing AML",
});

export enum TransactionState {
  PENDING = "PENDING",
  APPROVED = "APPROVED",
  DECLINED = "DECLINED",
}

export const additionalFeatures: Array<typeof BillableApi.T> = [
  "CONSENT_NOTE",
  "ONGOING_AML",
];
